import { useContext } from 'react';
import { AuthContextV2 } from '../contexts/AuthContextV2';

export const useAuthV2 = () => {
  const context = useContext(AuthContextV2);
  if (context === undefined) {
    throw new Error('useAuthV2 must be used within an AuthProviderV2');
  }
  return context;
};
